import styled from "styled-components/macro";
import { DefaultFont } from "styles/fonts";

export const ImageSubtitle = styled.p`
  font-size: 16px !important;
  margin-bottom: 10em;

  @media ${(props) => props.theme.media.phone} {
    margin-bottom: 3em;
    font-size: 16px;
  }
`;

export const FullWidthImage = styled.div`
  height: 20em;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  margin-bottom: 0.6em;
  
  .image {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

export const FullWidthSection = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  text-align: center;
  background-color: #FFF7F3;
  padding: 2em 30% 2em 30%;
  margin-bottom: 10em;
  
  & > hr {
    margin: 0 30% 1em 30%;
    border: none;
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.primary};
    height: 1px;
  }
  
  & > span {
    ${DefaultFont};
    font-weight: 400;
    font-size: 18px;
    @media ${(props) => props.theme.media.phone} {
      font-weight: 400;
      font-size: 18px;
    }
  }
  
  @media ${(props) => props.theme.media.tablet} {
    padding: 2em 10% 2em 10%;
  }
  @media ${(props) => props.theme.media.phone} {
    padding: 2em 1em 2em 1em;
    margin-bottom: 3em;
  }
`;

export const RevFlexSection = styled.div<{ lastMember?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  
  align-items: center;
  
  gap: 2rem;
  margin-bottom: ${(props) => props.lastMember ? "0" : "10em"};

  .image {
    flex: 1 1 40%;
    
    width: 100%;
    min-width: 20em;
    
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 8px;
  }

  .missionimage {
    flex: 1 1 40%;

    width: 100%;
    min-width: 20em;

    aspect-ratio: 4 / 3;
    object-fit: cover;
    border-radius: 8px;
  }

  & > div {
    flex: 1 1 40%;
  }

  @media ${(props) => props.theme.media.phone} {
    margin-bottom: ${(props) => props.lastMember ? "0" : "3em"};
  }
`;

export const FlexSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  
  align-items: center;
  
  gap: 2rem;
  margin-bottom: 10em;

  .image {
    flex: 1 1 40%;
    
    width: 100%;
    min-width: 20em;
    
    aspect-ratio: 4 / 3;
    object-fit: cover;
    border-radius: 8px;
  }
  

  & > div {
    flex: 1 1 40%;
  }

  @media ${(props) => props.theme.media.phone} {
    margin-bottom: 3em;
  }
`;
